import axios from "axios";
import { create } from "apisauce";
import Storage from "./storage";
import { InterceptorFunction } from "./Api/Interceptors";
import { checkRefreshToken } from "./Api/api";

export class Instance {
  static customAxiosInstance(token) {
    const userRefreshToken = Storage.get("user-access-refresh-token");
    const customAxiosInstance = axios.create();
    InterceptorFunction(customAxiosInstance, token, process.env.REACT_APP_API_KEY);

    checkRefreshToken(customAxiosInstance, userRefreshToken);

    const apisauceInstance = create({
        axiosInstance: customAxiosInstance,
    });
    return apisauceInstance;
  }

  
}
export default Instance;
